import {Component, EventEmitter, inject, Output} from '@angular/core';
import {Toolbar} from 'primeng/toolbar';
import {ButtonModule} from 'primeng/button';
import {Router} from '@angular/router';
import {
  UnitCompanySelectionComponent
} from '../../shared/components/unit-company-selection/unit-company-selection.component';

@Component({
  selector: 'app-navbar',
  imports: [
    Toolbar,
    ButtonModule,
    UnitCompanySelectionComponent,
  ],
  templateUrl: './navbar.component.html',
  styleUrl: './navbar.component.scss',
})
export class NavbarComponent {
  @Output() toggleSidebar = new EventEmitter<void>();
  private readonly router = inject(Router);

  onToggleSidebar() {
    this.toggleSidebar.emit();
  }

  logout() {
    sessionStorage.clear();
    this.router.navigate(['login']);
  }
}
